import lodashMerge from 'lodash/merge';
import { workspaceDefaultProperties } from '../../../workspaces/workspaceDefaultProperties';
export function mapWorkspaces(workspaces, options = {}) {
    const { mergeWithDefaultProperties = true, ignoreKeys = {}, source, } = options;
    const mapObject = {};
    const sourceObject = source ? { source } : {};
    for (const key in workspaces) {
        if (!(key in ignoreKeys)) {
            if (mergeWithDefaultProperties) {
                mapObject[key] = lodashMerge({}, workspaceDefaultProperties, workspaces[key], sourceObject);
            }
            else {
                mapObject[key] = { ...workspaces[key], ...sourceObject };
            }
        }
    }
    return mapObject;
}
